// TODO: Merge this with the other contact form script

document
	.querySelectorAll<HTMLFormElement>('.ContactForm_contact__BZ0Hn form')
	.forEach(form => {
		const status = form.querySelector('.ContactForm_output__ZMUW6')!
		const sourceSelect = form.querySelector<HTMLSelectElement>(
			'.ContactForm_field__dZ6rx select'
		)!
		const sourceOther = sourceSelect.nextElementSibling as HTMLInputElement
		const submit = form.querySelector<HTMLButtonElement>('button')!

		sourceSelect.addEventListener('change', () => {
			if (sourceSelect.value.toLowerCase() === 'other') {
				sourceSelect.removeAttribute('name')
				sourceOther.setAttribute('name', 'traffic-source')
				sourceOther.style.display = 'block'
				sourceOther.disabled = false
				sourceOther.focus()
			} else {
				sourceOther.removeAttribute('name')
				sourceSelect.setAttribute('name', 'traffic-source')
				sourceOther.disabled = true
				sourceOther.style.display = 'none'
			}
			console.log(sourceSelect.value)
		})

		form.addEventListener('submit', async e => {
			e.preventDefault()

			const formData = new FormData(form)

			// console.log(Array.from(formData))

			const crmPromises = [
				fetch('/wp-admin/admin-ajax.php', {
					method: 'POST',
					body: formData,
				}),
			]

			const action = form.getAttribute('action')
			if (action) {
				formData.delete('action')
				formData.delete('nonce')

				crmPromises.push(
					fetch(action, {
						method: 'POST',
						headers: { Accept: 'application/json' },
						body: formData,
					})
				)
			}

			const [crmResponse, formspreeResponse] = await Promise.allSettled(
				crmPromises
			)

			if (crmResponse.status === 'fulfilled') {
				const crmBody = await crmResponse.value.json()
				// console.log({ crmBody })
			}

			if (formspreeResponse.status === 'fulfilled') {
				const formspreeBody = await formspreeResponse.value.json()
				console.log({ formspreeBody })
			}

			status.textContent = "Thank's for your message!"
			submit.disabled = true
		})
	})
